import {gsap} from "../Utility/gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {observeElementResize} from "../Utility/utils";

const parallaxGrids = new Set();

export default function ParallaxGridBlock(){
        const currentParallaxGrids = document.querySelectorAll(".parallax-grid");
        set_parallax_grid_body_class(currentParallaxGrids);

        currentParallaxGrids.forEach((el) => {
            const trigger = el.querySelector(".static-content");
            const endTrigger = el.querySelector(".moving-content");

            if(!parallaxGrids.has(el)){
                parallaxGrids.add(el);
                observeElementResize(endTrigger,(entry)=>{
                    // Ensure the endTrigger bottom position is properly
                    // recognized by GSAP
                    const resizeEvent = new Event('resize');
                    window.dispatchEvent(resizeEvent);

                    entry.target.style.setProperty('--grid-width',entry.target.clientWidth);
                })
            }



            if(!window.wp?.editor) {


                const timeline = gsap.timeline({
                    id: "parallax-grid",
                    scrollTrigger: {
                        trigger,
                        endTrigger,
                        pin: true,
                        pinSpacing: false,
                        scrub: true,
                        start: "top top",
                        end: "bottom bottom",
                    }
                });
                // Taken from https://codepen.io/GreenSock/pen/qBjyPOw?editors=1010
                // adjusted start value.
                // no idea how this works.
                // forgive me.
                endTrigger.querySelectorAll('[data-speed]').forEach(mvEl => {
                    gsap.to(mvEl, {
                        y: function () {
                            return (1 - parseFloat(mvEl.getAttribute("data-speed"))) * (ScrollTrigger.maxScroll(window) - (this.scrollTrigger ? this.scrollTrigger.start : 0))
                        },
                        ease: "none",
                        scrollTrigger: {
                            trigger: mvEl,
                            start: "top bottom",
                            end: "max",
                            invalidateOnRefresh: true,
                            scrub: true
                        }
                    });
                });
            }

        });
}

function set_parallax_grid_body_class(blocks){
    const body = document.querySelector('body');
    const gridClass = 'has-parallax-grid-block';
    if(blocks.length && !body.classList.contains(gridClass)){
        body.classList.add(gridClass);
    }
    else if(!blocks.length && body.classList.contains(gridClass)) {
        body.classList.remove(gridClass);
    }
}